(ns frontend.ui.component.text-input-group.style
  (:require
   [frontend.ui.style.theme.core :refer
    [border-radius border-width color edge-size text-size]]
   [garden.util :refer [space-join]]))

(defn text-input-group
  []
  {:padding-bottom "16px"
   :border         "none"})
